import { Component, signal, OnInit,effect, computed, inject, DestroyRef } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ModelSelectionBarComponent } from "../model-selection-bar/model-selection-bar.component";
import { CvxFooterComponent } from "../cvx-footer/cvx-footer.component";
import {MatTabsModule} from '@angular/material/tabs';
import { SharedDataService } from '../../services/componentsServices/shared-data.service';
import { UserProfileStore } from '../../store/user-profile.store';
import { PermissionService } from '../../services/security/permission.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-cvx-main',
    imports: [RouterOutlet, ModelSelectionBarComponent, CvxFooterComponent, MatTabsModule], //MatTabsModule
    templateUrl: './cvx-main.component.html',
    styleUrl: './cvx-main.component.scss'
})
export class CvxMainComponent implements OnInit {

    protected lastSync = signal<string>('2024-10-25');
    project: string = '';
    activeTabIndex: number =0;
    areTabsEnabled = signal(false);
  private userProfileStore = inject(UserProfileStore);
  private permission = inject(PermissionService);
  private destroyRef = inject(DestroyRef);
  readonly canViewModelAccuracy = computed(() => this.permission.can('modelAccuracy:view'));
  readonly canViewTrading = computed(() => this.permission.can('tradingStrategy:view'));
  readonly canViewModelPredictions = computed(() => this.permission.can('modelPredictions:view'));
  readonly canViewModelDefinitions = computed(() => this.permission.can('modelDefinitions:view'));
  readonly canViewFeedback = computed(() => this.permission.can('feedback:give'));
    readonly tabRoutes = [
      'model-predictions',
      'model-accuracy',
      'trading-strategy',
      'model-definitions',
      'feedback'
    ];

    constructor(private router: Router, private route: ActivatedRoute,private SharedDataService:SharedDataService){

      effect(() => {
        this.project = this.SharedDataService.getProject(); 
        this.checkIfTabsAreEnabled();
        this.enforceModelPredictionsRouteWithoutProject();
      });

    }

    ngOnInit(){

      
      this.SharedDataService.tabIndex$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(index => {
        this.activeTabIndex = index;
      });

      this.router.events
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter((event) => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.syncActiveTabFromRoute();
          this.enforceModelPredictionsRouteWithoutProject();
        });

      this.syncActiveTabFromRoute();
      this.enforceModelPredictionsRouteWithoutProject();
    }

    private getCurrentTabRouteFromUrl(): string | null {
      const cleanUrl = this.router.url.split('?')[0].split('#')[0];

      for (const route of this.tabRoutes) {
        if (
          cleanUrl === `/${route}` ||
          cleanUrl.endsWith(`/${route}`) ||
          cleanUrl.includes(`/${route}/`)
        ) {
          return route;
        }
      }

      return null;
    }

    private syncActiveTabFromRoute() {
      const currentRoute = this.getCurrentTabRouteFromUrl();
      if(currentRoute){
        const routeIndex = this.tabRoutes.indexOf(currentRoute);
        if (routeIndex >= 0) {
          this.activeTabIndex = routeIndex;
        }
      }
    }

    private enforceModelPredictionsRouteWithoutProject() {
      if (this.project.length > 0) {
        return;
      }

      const currentRoute = this.getCurrentTabRouteFromUrl() ?? '';
      if (currentRoute && currentRoute !== 'model-predictions') {
        this.activeTabIndex = 0;
        this.router.navigate(['/model-predictions'], { replaceUrl: true });
      }
    }

    checkIfTabsAreEnabled(){
      const isEnabled = !!this.project && this.SharedDataService.getIsNavbarEnabled();
      this.areTabsEnabled.set(isEnabled);
    }

    onTabChange(index: number){
      this.project = this.SharedDataService.getProject(); 
      this.activeTabIndex = index;
      this.router.navigate(['/', this.tabRoutes[index]]);
    }

    isTabDisabled(tab: number): boolean {
      let thereIsNoProjectSelected=this.project.length === 0;

      let isDisabled = true;
      // if(this.areTabsEnabled()) {
      //   isDisabled = this.project.length === 0;
      // }

      if(this.areTabsEnabled() && !thereIsNoProjectSelected) {
        switch(tab) {
          case 1: // Model Predictions
            isDisabled = !this.canViewModelPredictions();
            break;
          case 2: // Model Accuracy
            isDisabled = !this.canViewModelAccuracy();
            break;
          case 3: // Trading Strategy
            isDisabled = !this.canViewTrading();
            break;
          case 4: // Model Definitions
            isDisabled = !this.canViewModelDefinitions();
            break;
          case 5: // Feedback
            isDisabled = !this.canViewFeedback();
            break;
          default:
            isDisabled = true;
            break;
        }
      }



      return isDisabled;
    }
}
